<ng-template #contenido let-modal>
    <div class="modal-header">
        <h4 class="modal-title"></h4>
        <button type="button" class="btn-close btn-rounded" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <app-advancedtable [WsURL]=strWsURLModal (RetornoModal)=RetornoModal($event) [mostrarModal]=true>
        </app-advancedtable>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success btn-rounded" (click)="modal.close()"> ok</button>
    </div>
</ng-template>

<div class="offcanvas-header">
    <button type="button" class="btn-close text-right" aria-label="Close" (click)="activeOffcanvas.dismiss()"></button>
</div>

<div class="p-3" [ngClass]="this.TipoPantalla=='LISTADO' ? 'campo campo-sm' : '' " *ngIf="this.form_template" style="overflow-y: inherit;">

    <div class="row" *ngIf="reportes.length > 0">
        <button *ngIf="collapsedReportes;else ocultarFiltros" type="button" class="btn btn-link text-left"
            (click)="toggleReportes()" style="width: auto;">Ver reportes</button>
        <ng-template #ocultarFiltros>
            <button type="button" class="btn btn-link text-left" (click)="toggleReportes()" style="width: auto;">Ocultar
                reportes</button>
        </ng-template>
    </div>

    <div class="row mb-3" #collapseRep="ngbCollapse" [(ngbCollapse)]="collapsedReportes" *ngIf="reportes.length > 0">
        <div class="col-12">
            <div class="mt-1 mb-1">
                <label for="">Tipo de reporte</label>
                <ng-select [(ngModel)]="reporteSel" [items]="reportes" bindLabel="SYS10DES" bindValue="SYS10CON">
                </ng-select>
            </div>
        </div>
        <div class="col-12">
            <div class="mt-1 mb-1">
                <label for="">Formato</label>
                <ng-select [(ngModel)]="tipoReporteSel" (change)="SelectReporte()">
                    <ng-option value="PDF">PDF</ng-option>
                    <ng-option value="XLS">Excel</ng-option>
                </ng-select>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="text-right">
            <button type='button' class="btn btn-info btn-label waves-light btn-sm" (click)="ValidarFormulario()">
                <i class="bx bx-search-alt-2 label-icon" style="pointer-events:none ;"></i> Buscar
            </button>
        </div>
    </div>
    <form [formGroup]="myFormGroup" (submit)="ValidarFormulario()">

        <ng-container *ngIf="form_template.length > 0">
            <div class="row">

                <ng-container *ngFor="let form_elem of form_template[0].FiltrosExpuestos;let indice = index">

                    <ng-container [ngSwitch]="form_elem.type">
                        <ng-container *ngSwitchCase="'textbox_modal'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label for="filtro_{{form_elem.label}}" (click)="AbrirModal(contenido, form_elem)">
                                        {{form_elem.title}}>
                                    </label>
                                    <input type="text" class="form-control" id="filtro_{{form_elem.label}}"
                                        (keypress)="enter($event)" name="{{form_elem.label}}"
                                        placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}">
                                    <div *ngIf="form_elem.validators.required">
                                        <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                            class="alert-requerido">
                                            {{form_elem.validators.msg_validacion}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'fotografia'">
                            <div class="col-md-12">
                                <div style="text-align: center;" class="position-relative mb-1">
                                    <img src="data:image/png;base64,
                        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"
                                        alt="">
                                </div>
                            </div>
                        </ng-container>


                        <ng-container *ngSwitchCase="'textbox'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label for="filtro_{{form_elem.label}}">{{form_elem.title}}</label>
                                    <input type="text" id="filtro_{{form_elem.label}}" (keypress)="enter($event)"
                                        name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                        [readonly]="form_elem.disabled=='S'" formControlName="{{form_elem.label}}"
                                        class="form-control">
                                    <div *ngIf="form_elem.validators.required">
                                        <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                            class="alert-requerido">
                                            {{form_elem.validators.msg_validacion}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'textbox_date'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label for="{{form_elem.label}}">{{form_elem.title}}</label>
                                    <input type="date" id="filtro_{{form_elem.label}}" (keypress)="enter($event)"
                                        name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                        [readonly]="form_elem.disabled=='S'" formControlName="{{form_elem.label}}"
                                        class="form-control">
                                    <div *ngIf="form_elem.validators.required">
                                        <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                            class="alert-requerido">
                                            {{form_elem.validators.msg_validacion}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'number'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label for="{{form_elem.label}}">{{form_elem.title}}</label>
                                    <input type="number" id="filtro_{{form_elem.label}}" (keypress)="enter($event)"
                                        name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                        [readonly]="form_elem.disabled=='S'" formControlName="{{form_elem.label}}"
                                        class="form-control">
                                    <div *ngIf="form_elem.validators.required">
                                        <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                            class="alert-requerido">
                                            {{form_elem.validators.msg_validacion}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>


                        <ng-container *ngSwitchCase="'select_anterior_disabled'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label for="{{form_elem.label}}">{{form_elem.title}}</label>
                                    <select class="form-control" id="filtro_{{form_elem.label}}"
                                        formControlName="{{form_elem.label}}">
                                        <option *ngFor="let opt of form_elem.options" [value]="opt.value">
                                            {{opt.text}}
                                        </option>
                                    </select>
                                    <div *ngIf="form_elem.validators.required">
                                        <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                            class="alert-requerido">
                                            {{form_elem.validators.msg_validacion}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'select_url'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label for="{{form_elem.label}}" class=" 'col-form-label'"
                                        (click)="AbrirModal(contenido, form_elem)" style="text-decoration: underline">
                                        {{form_elem.title}}
                                        <span *ngIf="form_elem.validators.required">(*)</span>
                                    </label>

                                    <input type="text" class="form-control" (keypress)="enter($event)"
                                        id="filtro_{{form_elem.label}}" name="{{form_elem.label}}"
                                        placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}"
                                        [readonly]="form_elem.disabled=='S'">
                                    <div *ngIf="form_elem.validators.required">
                                        <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                            class="alert-requerido">
                                            {{form_elem.validators.msg_validacion}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>


                        <ng-container *ngSwitchCase="'select'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label for="{{form_elem.label}}">{{form_elem.title}}</label>
                                    <ng-select formControlName="{{form_elem.label}}" id="filtro_{{form_elem.label}}"
                                        (change)="CboClick(form_elem.ComboClick, form_elem.ComboClickDestName)"
                                        [readonly]="form_elem.disabled=='S'" [items]="form_elem.options"
                                        bindLabel="text" bindValue="value">
                                    </ng-select>
                                    <div *ngIf="form_elem.validators.required">
                                        <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                            class="alert-requerido">
                                            {{form_elem.validators.msg_validacion}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'select_multiple'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label for="{{form_elem.label}}">{{form_elem.title}}</label>
                                    <ng-select formControlName="{{form_elem.label}}" id="{{form_elem.label}}"
                                        [(ngModel)]="this.ngmodels[form_elem.label]"
                                        [readonly]="form_elem.disabled=='S'" [items]="form_elem.options"
                                        bindLabel="text" bindValue="value" multiple="true"
                                        labelForId="{{form_elem.label}}">
                                    </ng-select>
                                    <div *ngIf="form_elem.validators.required">
                                        <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                            class="alert-requerido">
                                            {{form_elem.validators.msg_validacion}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'textarea'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label for="{{form_elem.label}}">{{form_elem.title}}</label>
                                    <textarea name="{{form_elem.name}}" class="form-control"
                                        id="filtro_{{form_elem.label}}" (keypress)="enter($event)"
                                        placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}">
                    </textarea>
                                    <div *ngIf="form_elem.validators.required">
                                        <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                            class="alert-requerido">
                                            {{form_elem.validators.msg_validacion}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'checkbox'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label class="form-check-label"
                                        for="{{form_elem.label}}">{{form_elem.title}}</label>
                                    <div class="form-check form-switch form-switch-md">
                                        <input type="checkbox" id="filtro_{{form_elem.label}}" class="form-check-input"
                                            placeholder="{{form_elem.placeholder}}"
                                            formControlName="{{form_elem.label}}">
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'radio'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label class="form-check-label"
                                        for="{{form_elem.label}}">{{form_elem.title}}</label>
                                    <input type="radio" id="filtro_{{form_elem.label}}" class="form-check-input"
                                        placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}">
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'select_url_anterior'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label for="{{form_elem.label}}">{{form_elem.title}}</label>
                                    <app-cbo-select>
                                        <ng-template #selectedTemplate let-shark>
                                            {{ shark?.name || "Shark" }}
                                        </ng-template>

                                        <ng-template #optionTemplate let-shark let-id="index">
                                            <a class="dropdown-item" [style.color]="id % 2 == 0 ? 'black' : 'blue'">
                                            </a>
                                        </ng-template>
                                    </app-cbo-select>
                                </div>
                            </div>
                        </ng-container>


                        <ng-container *ngSwitchCase="'span'">
                            <div class="col-12">
                                <div class="mt-1 mb-1">
                                    <label for="{{form_elem.label}}">{{form_elem.title}}</label>
                                    <input type="text" class="form-control" id="filtro_{{form_elem.label}}"
                                        (keypress)="enter($event)" name="{{form_elem.label}}"
                                        placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}"
                                        disabled>

                                    <div *ngIf="form_elem.validators.required">
                                        <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid"
                                            class="alert-requerido">
                                            {{form_elem.validators.msg_validacion}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'hidden'">
                            <input type="hidden" class="form-control" id="filtro_{{form_elem.label}}"
                                name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                                formControlName="{{form_elem.label}}">
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </form>

    <div class="col-12" *ngIf="SYS02CON != ''">
        <label for="">Filtro Guardados</label>
        <div class="row gx-0 align-items-center">
          <div class="col-8">
            <ng-select [items]="filtro_guardado" [(ngModel)]="filtroSel" bindLabel="SYS20DES"
              (change)="onFilter($event)" placeholder="Filtros guardados"></ng-select>
          </div>
          <div class="col-4">
            <button type="button" class="btn btn-sm btn-success ms-1" title="Guardar filtro"
              (click)="GuardarFiltro()">
              <i class="fa fa-floppy-disk"></i>
            </button>
            <button type="button" class="btn btn-sm btn-danger ms-1" title="Borrar filtro"
              (click)="DELETE_FILTRO()">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
    </div>

    <div class="row mt-3 mb-2">
        <div class="text-right">
            <button type='button' class="btn btn-info btn-label waves-light btn-sm" (click)="ValidarFormulario()">
                <i class="bx bx-search-alt-2 label-icon" style="pointer-events:none ;"></i> Buscar
            </button>
        </div>
    </div>

</div>

<app-scroll-to-top>
</app-scroll-to-top>